/**
 * @module support/pdl
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Directive, ElementRef, Renderer2, OnInit, Input } from '@angular/core';

@Directive({
  selector: '[tmoPdl]',
})
export class PdlDirective implements OnInit {
  @Input() public pdlCmpId: string;
  @Input() public pdlFields: string;
  @Input() public pdlCtaId: string;
  @Input() public pdlEvents: string;
  @Input() public pdlRepeatedComponent: string;
  @Input() public pdlPageComponentId: string;

  private pdlData: object;
  constructor() {}

  public ngOnInit(): void {
    this.pdlData = {
      pdlCmpId: this.pdlCmpId,
      pdlFields: this.pdlFields,
      pdlCtaId: this.pdlCtaId,
      pdlEvents: this.pdlEvents,
      pdlRepeatedComponent: this.pdlRepeatedComponent,
      pdlPageComponentId: this.pdlPageComponentId,
    };
  }
}
